import { t } from "@lingui/macro"

import { CommunityPostStatus } from "src/views/community-posts-and-comments/types"

export const COMMUNITY_POST_STATUS_CHIP_LABELS = {
    [CommunityPostStatus.SCHEDULED]: {
        get name() {
            return t`community-posts-view.status-chip-scheduled-status`
        },
    },
    [CommunityPostStatus.PUBLISHED]: {
        get name() {
            return t`community-posts-view.status-chip-published-status`
        },
    },
}
